import { render, staticRenderFns } from "./NewAccountTypeModal.vue?vue&type=template&id=6aac9adc&lang=pug&"
import script from "./NewAccountTypeModal.vue?vue&type=script&lang=js&"
export * from "./NewAccountTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports